import React from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@sg/garnish';
import { BodyText, FallbackImage, IllusEmpty_2, PRODUCT_THUMBNAIL_IMAGE_CONFIG } from '@sg/garnish';

// ────────────────────────────────────────────────────────────────────────────────

export const OrderPlaybackLineItem = (props: OrderPlaybackLineItemProps) => {
  const { name, imageUrl, quantity } = props;

  return (
    <View style={styles.container}>
      <FallbackImage
        contentFit="contain"
        style={styles.image}
        baseUrl={imageUrl}
        defaultImage={IllusEmpty_2}
        cloudinaryConfig={PRODUCT_THUMBNAIL_IMAGE_CONFIG}
      />

      <View style={styles.detailsColumn}>
        <BodyText bold sizeMatch={['18']} maxFontSizeMultiplier={1.2} numberOfLines={2}>
          {quantity > 1 ? `${quantity}x ${name}` : name}
        </BodyText>
      </View>
    </View>
  );
};

// ─── Constants ──────────────────────────────────────────────────────────────────

const THUMBNAIL_SIZE = 64;

// ─── Styles ─────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    paddingHorizontal: theme.spacing['1'],
    height: 80,
    alignItems: 'center',
    gap: theme.spacing['3'],
  },
  detailsColumn: {
    flex: 1,
    gap: theme.spacing['1'],
  },
  image: {
    width: THUMBNAIL_SIZE,
    height: THUMBNAIL_SIZE,
  },
});

// ─── Types ──────────────────────────────────────────────────────────────────────

type OrderPlaybackLineItemProps = Readonly<{
  name: string;
  imageUrl?: string;
  quantity: number;
}>;
